import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CustomSelectorPage } from './custom-selector';

@NgModule({
  declarations: [
    CustomSelectorPage,
  ],
  imports: [
    IonicPageModule.forChild(CustomSelectorPage)
  ],
})
export class CustomSelectorPageModule {}


// WEBPACK FOOTER //
// ./src/pages/custom-selector/custom-selector.module.ts